import * as React from 'react';
import { JSX } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, IconButton } from '@mui/material';
import styled from 'styled-components';
import CloseSvg from '../../images/crossBlack.svg';

const Prompt = (props: Props) => {
	const { onClose, open = true, title, content, actions, minWidth, alignLeft, smallFontWeight, isBlackColor } = props;

	return (
		<Dialog
			onClose={onClose}
			open={open}
			PaperProps={{
				style: {
					borderRadius: '10px',
					width: '100%',
					minWidth: minWidth ?? '0px',
					marginTop: '64px' // Double of default, so top won't overlap with iPhone dynamic island bar
				}
			}}
		>
			{onClose && (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8
					}}
				>
					<img src={CloseSvg} alt="close icon" />
				</IconButton>
			)}
			{props.icon && <Img src={props.icon} alt={props.iconAlt} />}
			<Title
				$largeMargin={!props.icon}
				$alignLeft={alignLeft}
				$blackColour={isBlackColor}
				$smallFontWeight={smallFontWeight}
			>
				{title}
			</Title>
			<ContentContainer>{content}</ContentContainer>
			{actions && <Actions>{actions}</Actions>}
		</Dialog>
	);
};

export default Prompt;

interface Props {
	smallFontWeight?: boolean;
	isBlackColor?: boolean;
	alignLeft?: boolean;
	onClose?: () => void;
	open?: boolean;
	icon?: '*.svg';
	iconAlt?: string;
	title: string;
	content: JSX.Element | JSX.Element[];
	actions?: JSX.Element | JSX.Element[];
	minWidth?: string;
}

const Title = styled.h2<{
	$largeMargin: boolean;
	$alignLeft: boolean;
	$smallFontWeight: boolean;
	$blackColour: boolean;
}>`
	font-size: 20px;
	font-weight: ${(props) => (props.$smallFontWeight ? '400' : '600')};
	line-height: 30px;
	text-align: ${(props) => (props.$alignLeft ? 'left' : 'center')};
	margin-top: ${(props) => (props.$largeMargin ? '49px' : '0')};
	margin-bottom: 0;
	padding: 0 20px;
	color: ${(props) => (props.$blackColour ? '#000' : props.theme.brandingColourHeavy)};
`;

const ContentContainer = styled(DialogContent)`
	text-align: center;
`;

const Actions = styled(DialogActions)`
	display: block;
	padding: 5px 20px 20px 20px;

	> * {
		margin-bottom: 20px !important;
		margin-left: 0 !important;

		&:last-child {
			margin-bottom: 0 !important;
		}
	}
`;

const Img = styled.img`
	width: 96px;
	height: 96px;
	margin: 50px auto 24px auto;
`;
